import React, { Component } from 'react'
import { connect } from 'react-redux'

import './_progressbar.css'

class ProgressBar extends Component {
  static defaultProps = {
    step: 0,
    reverse: 'normal'
  }

  render() {

    const { reverse, step } = this.props

    return (
      <div className="progressbar">
        <div className="progress-mask"></div>
        <div className={`hover-mask step${step} ${reverse}`}></div>
        <div className="progress-line"></div>
      </div>
    );
  }
}

export default connect()(ProgressBar)


// WEBPACK FOOTER //
// ./src/components/progressbar/ProgressBar.js